// ============================================================================
// FSA REPORT ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaReports';

export const fsaReportEndpoints = {
  /** GET /api/v1/FsaReports/by-engagement/{engId} */
  listByEngagement: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** GET /api/v1/FsaReports/by-engagement/{engId}/{reportId} */
  hydrate: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId`, { engId, reportId }),

  /** PUT /api/v1/FsaReports/by-engagement/{engId}/{reportId} */
  save: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId`, { engId, reportId }),

  /** GET /api/v1/FsaReports/by-engagement/{engId}/{reportId}/pdf */
  pdf: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/pdf`, { engId, reportId }),

  /** POST /api/v1/FsaReports/by-engagement/{engId}/{reportId}/exclude (FSA-2.2) */
  exclude: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/exclude`, { engId, reportId }),

  /** POST /api/v1/FsaReports/by-engagement/{engId}/{reportId}/include (FSA-2.2) */
  include: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/include`, { engId, reportId }),

  /** POST /api/v1/FsaReports/by-engagement/{engId}/{reportId}/import-from-prior-year (FSA-2.3 Roll Forward) */
  importFromPriorYear: (engId: ID, reportId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/:reportId/import-from-prior-year`, { engId, reportId }),
} as const;

export default fsaReportEndpoints;
